const getters = {
  getCompany(state) {
    return state.company
  },
  getUser(state) {
    return state.user;
  },
  getUserData(state) {
    return state.userData;
  },
  isUserAuth(state) {
    return !!state.user;
  },
  getError(state) {
    return state.error;
  },
  loggedIn(state) {
    return state.loggedIn;
  },
  getAdminToken(state) {
    return state.adminToken;
  },
  getEmailChecked(state) {
    return state.emailChecked;
  },
  getLoginDialog(state) {
    return state.loginDialog;
  },
  getForgotDialog(state) {
    return state.forgotDialog;
  },
  getRegisterDialog(state) {
    return state.registerDialog;
  },
  getFeedbackModal(state) {
    return state.feedbackModal;
  },
  getFeedback(state) {
    return state.feedback;
  },
  getLoadingPage(state) {
    return state.loadingPage;
  },
  getGoLiveEnabled(state) {
    return state.video.golive;
  },
  getVideo(state) {
    return state.video;
  },
  getVideos(state) {
    return state.videos;
  },
};

export default getters;